import { useMutation } from '@apollo/client';
import { createError } from '@common/neo.tax';

import {
  CreateMergeDevAccessTokenForTicketingMutation,
  CreateMergeDevAccessTokenForTicketingMutationVariables,
  CREATE_MERGE_DEV_ACCESS_TOKEN_FOR_TICKETING,
} from '@neo.tax/shared/graphql';

import { useCurrentUser } from '../useCurrentUser';
import { UseMergeDevTicketingParams } from './types';
import { useMergeDev } from './useMergeDev';

export const useMergeDevTicketing = ({
  companyId,
  isParentReady,
  onError,
  onSuccess,
  provider,
}: UseMergeDevTicketingParams): { onOpen: () => void } => {
  const { user } = useCurrentUser();
  if (!user) {
    throw createError('MissingCurrentUserError', 'Loader guard should have prevented rendering without current user');
  }

  const [createMergeDevAccessTokenForTicketing, { error }] = useMutation<
    CreateMergeDevAccessTokenForTicketingMutation,
    CreateMergeDevAccessTokenForTicketingMutationVariables
  >(CREATE_MERGE_DEV_ACCESS_TOKEN_FOR_TICKETING);

  return useMergeDev(
    { companyId, isParentReady, onError, onSuccess, provider },
    async (publicToken: string) => {
      await createMergeDevAccessTokenForTicketing({
        variables: {
          userId: user.id,
          input: { companyId, mergeDevPublicToken: publicToken, ticketingProvider: provider },
        },
      });
    },
    error,
    user.id,
  );
};
